<div flex fxLayout="row" xLayout.xs="column" fxLayoutAlign="space-between center" class="cabecera">
    <h1 class="titulo">Revisa y firma los documentos</h1>
    <div class="boton">
        <app-boton-accion [datosProceso]="datosProceso"></app-boton-accion>
    </div>
</div>

<div flex fxLayout="row" xLayout.xs="column" fxLayoutAlign="space-between center">
    <div fxFlex="100">
        <pdf-viewer [src]="pdfSource" [show-all]="true" [page]="pageNumber" [fit-to-page]="true" [original-size]="true">
        </pdf-viewer>
    </div>
</div>